/**
 * Utility function to format error messages from API responses
 * Handles Pydantic validation errors (arrays of objects) and simple string errors
 */
const FIELD_LABELS = {
  email: 'Email',
  password: 'Mot de passe',
  first_name: 'Prénom',
  last_name: 'Nom',
  phone: 'Téléphone',
  cc_email: 'Email CC',
};

export const formatErrorMessage = (error, defaultMessage = 'Une erreur est survenue') => {
  if (!error?.response?.data?.detail) {
    return defaultMessage;
  }

  const detail = error.response.data.detail;

  // If detail is an array (Pydantic validation errors)
  if (Array.isArray(detail)) {
    return detail.map(err => {
      const rawField = err.loc ? err.loc[err.loc.length - 1] : 'champ';
      const field = FIELD_LABELS[rawField] || rawField;
      let msg = err.msg || '';
      // Traductions des messages Pydantic les plus courants
      if (/at least (\d+) character/.test(msg)) {
        msg = msg.replace(/String should have at least (\d+) characters?/, 'doit contenir au moins $1 caractères');
      } else if (/valid email address/.test(msg)) {
        msg = "n'est pas une adresse email valide";
      } else if (/Field required/i.test(msg)) {
        msg = 'est obligatoire';
      }
      return `${field} : ${msg}`;
    }).join(' • ');
  }

  // If detail is a string
  if (typeof detail === 'string') {
    return detail;
  }

  // If detail is an object (ex: {code, message} pour PLAN_LIMIT_EXCEEDED)
  if (typeof detail === 'object') {
    return detail.message || detail.msg || JSON.stringify(detail);
  }

  return defaultMessage;
};
